'use strict';

/** @type {import('./max')} */
module.exports = Math.max;



//////////////////
// WEBPACK FOOTER
// ../math-intrinsics/max.js
// module id = 691
// module chunks = 0